<template>
    <div>
        <div
            v-if="loading"
            class="fixed top-0 left-0 w-full h-full z-[200] justify-center items-center flex bg-white bg-opacity-50"
        >
            <Loader />
        </div>
        <NuxtLayout>
            <NuxtPage />
        </NuxtLayout>
    </div>
</template>
<script setup lang="ts">

import Loader from "@/components/core/Loader.vue";
import { useLoading } from "@/composables/useLoading";
const { loading } = useLoading();

</script>